var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('A',{class:_vm.CssClass,attrs:{"href":_vm.To,"target":_vm.m_Target},on:{"click":_vm.OnLinkClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }